import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Tag, PackageSearch, Upload, Check } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { materialCategories, IMG } from "../lib/data";
import { Icon } from "../components/Icon";
import PageHero from "../components/PageHero";
import CTASection from "../components/CTASection";

const TelecomMaterials = () => {
  const { t, lang } = useLanguage();
  const navigate = useNavigate();
  const go = () => navigate("/request-quotation");

  return (
    <div data-testid="telecom-materials-page">
      <PageHero label={t.materialsPage.label} title={t.materialsPage.heading} sub={t.materialsPage.sub} image={IMG.engineer} />

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="glass p-5 mb-12 flex items-start gap-3" data-testid="materials-note">
            <Icon name="Info" size={18} className="text-[#D4AF37] mt-0.5 shrink-0" />
            <p className="text-sm text-slate-300">{t.materialsPage.note}</p>
          </div>

          <div className="space-y-10">
            {materialCategories.map((cat, i) => {
              const d = cat[lang];
              return (
                <motion.div
                  key={cat.id}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5 }}
                  className="grid lg:grid-cols-12 gap-6 bg-[#11203A] border border-white/12"
                  data-testid={`material-category-${cat.id}`}
                >
                  <div className="lg:col-span-3 relative min-h-[200px]">
                    <img src={cat.image} alt={d.title} className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#11203A] via-[#11203A]/30 to-transparent" />
                    <div className="absolute bottom-5 start-5 flex items-center gap-3">
                      <span className="w-10 h-10 grid place-items-center bg-[#D4AF37] text-[#0A1223]">
                        <Icon name={cat.icon} size={20} />
                      </span>
                      <h3 className="font-heading text-xl font-bold text-white">{d.title}</h3>
                    </div>
                  </div>

                  <div className="lg:col-span-6 p-7">
                    <div className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
                      {d.items.map((item) => (
                        <div key={item} className="flex items-center gap-2.5 text-sm text-slate-200">
                          <Check size={15} className="text-[#D4AF37] shrink-0" />
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="lg:col-span-3 p-7 lg:border-s border-white/12 flex flex-col gap-3 justify-center">
                    <button onClick={go} data-testid={`req-pricing-${cat.id}`} className="btn-gold inline-flex items-center justify-center gap-2 px-4 py-3 text-sm w-full">
                      <Tag size={16} /> {t.common.requestPricing}
                    </button>
                    <button onClick={go} data-testid={`req-availability-${cat.id}`} className="inline-flex items-center justify-center gap-2 px-4 py-3 text-sm w-full border border-white/20 text-white hover:bg-white/5 transition-colors">
                      <PackageSearch size={16} /> {t.common.requestAvailability}
                    </button>
                    <button onClick={go} data-testid={`upload-boq-${cat.id}`} className="inline-flex items-center justify-center gap-2 px-4 py-3 text-sm w-full border border-white/20 text-white hover:bg-white/5 transition-colors">
                      <Upload size={16} /> {t.common.uploadBOQ}
                    </button>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
};

export default TelecomMaterials;
